import { SearchNoResult, Loader } from "@ic-anywhere/ic-components";
import * as React from "react";
import { isEmpty } from "lodash-es";
import DashboardFilters from "./Filters/DashboardFilters";
import DashboardHeader from "./Header/DashboardHeader";
import { useEventsDashboard } from "./Hooks/useEventsDashboard";
import EventsList from "./List/EventsList";

export const Dashboard: React.FC = () => {
  const { isFetching, events } = useEventsDashboard();

  return (
    <div className="container-xxl">
      <DashboardHeader />
      <DashboardFilters />
      <div className={"d-flex justify-content-center"}>
        <Loader isVisible={isFetching} />
      </div>
      {isEmpty(events) && !isFetching && (
        <SearchNoResult title={"No event available"} icon="info_outline" containerClassName="mt-3" />
      )}
      <div className="row g-4 mt-3 mb-4">
        <EventsList events={events} />
      </div>
    </div>
  );
};
